require('./footer.scss');

export default class FooterComponent {
  constructor() {
    this.controller = FooterController;
    this.template = require('./footer.html');
  }
}

// @ngInject
class FooterController {
}



// WEBPACK FOOTER //
// ./src/modules/base/components/footer/footer.component.js